// Func = limiting Scope for this file
var lastScrollTop = 0;

if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    let itemsMenu = document.querySelectorAll('.privary-navigation .privary-navigation__item');
	itemsMenu.forEach((itemMenu)=>{
		if(itemMenu.querySelector('.submenu')){
			itemMenu.addEventListener('mouseenter',()=>{
				itemMenu.classList.add('hover');
				itemMenu.querySelector('.submenu').classList.add('show');
			});
			itemMenu.addEventListener('mouseleave',()=>{
				itemMenu.classList.remove('hover');
				itemMenu.querySelector('.submenu').classList.remove('show');
			})
		}
	})

    window.onload = function() {
		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		});
	};

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

	//email signup animation 
	if(document.getElementById('email-signup')){
		document.getElementById('email-signup_FNAME').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})
		document.getElementById('email-signup_LNAME').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})
		document.getElementById('email-signup_email_address').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})

	}

    //CMS forms label animation
	if(document.getElementsByClassName('form-module__field').length > 0){
		let allffields = document.getElementsByClassName('form-module__field');
		
        for(let j = 0; j < allffields.length; j++){
            
            if(allffields[j].getElementsByTagName('input').length > 0){
                if(allffields[j].getElementsByTagName('input')[0].type.toLowerCase() != 'checkbox' && allffields[j].getElementsByTagName('input')[0].type.toLowerCase() != 'radio'){
                    allffields[j].getElementsByTagName('input')[0].addEventListener('focus', function(){
                        this.parentElement.classList.add('moved');
                    })
                }
            }
            if(allffields[j].getElementsByTagName('select').length > 0){
                allffields[j].getElementsByTagName('select')[0].addEventListener('focus', function(){
                    this.parentElement.classList.add('moved');
                })
            }
            if(allffields[j].getElementsByTagName('textarea').length > 0){
                allffields[j].getElementsByTagName('textarea')[0].addEventListener('focus', function(){
                    this.parentElement.classList.add('moved');
                })
            }
        }
	}

	if(document.getElementById('email-signup')){
		let buttonSingUp = document.querySelector('#email-signup .signup-btn');
		document.querySelector('.email-signup .fields-wrap').insertAdjacentElement('beforeend', buttonSingUp);
	}

	document.querySelectorAll('.btn:not(.reset), .btn-white').forEach((button)=>{
		let textButton = button.textContent;
		let spanbtn = document.createElement('span');
		button.textContent = '';
		spanbtn.textContent = textButton;
		button.insertAdjacentElement('afterbegin', spanbtn);
	});

	if(document.getElementById('home') && document.querySelector('.btn-booking')){
		let buttonHeader = document.querySelector('.btn-booking');
		buttonHeader.addEventListener('click', function(e){
			e.preventDefault();
			let formId = "#"+buttonHeader.href.split('#')[1];
			animateTo(formId);
		});
	}

	if(window.location.hash){
		let hash = window.location.hash;
		if(hash != '' && hash != '#' && document.querySelector(hash)){
			animateTo(hash);
		}
	}

	if(document.querySelector('.form-module-wrapper')){
		document.querySelectorAll('.form-module-wrapper').forEach((text) => {
			text.querySelector('.form-module').classList.add('animate-fade','top');
		});
	}

	if(document.querySelector('.text-modules-wrapper')){
		document.querySelectorAll('.text-modules-wrapper').forEach((text) => {
		text.querySelector('.text-modules').classList.add('animate-fade','top');
	});
	}

	if(document.querySelector('.global-sitemap')){
		document.querySelector('.global-sitemap').classList.add('animate-fade', 'top');
	}

	if(document.querySelector('.js-scroll')){
        let buttonsAnchor = document.querySelectorAll('.js-scroll');
        buttonsAnchor.forEach((button)=>{
            button.addEventListener('click',(e)=>{
                let anchorElement = button.getAttribute('href');
				e.preventDefault();
				let headerHeight = document.querySelector('header').offsetHeight + 100;
				let element = document.querySelector(anchorElement).getBoundingClientRect();
				const scrollY = window.scrollY || document.documentElement.scrollTop;
				const scrollPosition = element.top + scrollY;
				window.scrollTo({
					top: scrollPosition - headerHeight,
					behavior: 'smooth'
				});
            })
        })
    }

	document.querySelector('#menu-mobile .close-menu').addEventListener('click', ()=>{
		document.getElementById('menu-mobile').classList.remove('show');
	})

	document.querySelector('.js-open-menu').addEventListener('click', ()=>{
		document.getElementById('menu-mobile').classList.add('show');
	});

	if(document.querySelector('.venues__filter')){
		let tabsVenues = document.querySelectorAll('.venues__filter .js-filter-venues');
		let allVenues = document.querySelectorAll('.venues__item, .venues__description');
		let lastClickVenues = null;

		tabsVenues.forEach((tab)=>{
			tab.addEventListener('click',()=>{
				let dataTag = tab.dataset.tag;
				if(lastClickVenues){
					lastClickVenues.classList.remove('active');
				}
				tab.classList.add('active');
				lastClickVenues = tab;
				allVenues.forEach((venue)=>{
					venue.classList.toggle('hidden', !venue.dataset.tag.includes(dataTag));
				})
			})
		})
		tabsVenues[0].click();
	}

	  const items = document.querySelectorAll('.js-margin-remove:not(.hidden)');
		document.querySelectorAll('.js-margin-remove').forEach(el => {
			el.classList.remove('is-last', 'is-last-2');
		});

		if (items.length >= 1) {
			items[items.length - 1].classList.add('is-last');
		}

		if (items.length >= 2) {
			items[items.length - 2].classList.add('is-last-2');
		}

})();

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}

//animation of scroll vanilla JS
function animateTo(target) {
	var gotoTarget = offset(document.querySelector(target)).top - 120
	var from = window.pageYOffset
	var to = gotoTarget
	var duration = 1300
	var start = new Date().getTime()

	var timer = setInterval(function () {
		var time = new Date().getTime() - start

		if (from <= to) {
			var yH = easeInOutQuart(time, from, to - from, duration)
		} else {
			var yH = easeInOutQuart(time, from, -(from - to), duration)
		}
		window.scrollTo(0, yH)
		if (time >= duration) clearInterval(timer)
	}, 1000 / 60)

	window.scrollTo(0, from)
}

//ease movement
function easeInOutQuart(t, b, c, d) {
	if ((t /= d / 2) < 1) return (c / 2) * t * t * t * t + b
	return (-c / 2) * ((t -= 2) * t * t * t - 2) + b
}

//window offset
function offset(el) {
	var rect = el.getBoundingClientRect(),
		scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
		scrollTop = window.pageYOffset || document.documentElement.scrollTop
	return {
		top: rect.top + scrollTop,
		left: rect.left + scrollLeft,
	}
}